import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    createCashItemBodySchema,
    createDepositResponseSchema,
} from "@common/schemas/domains/cashItem/cashItem.schema";

const c = initContract();

export const depositContract = c.router(
    {
        createDeposit: {
            method: "POST",
            path: "/:workspaceId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
            }),
            body: createCashItemBodySchema,
            responses: {
                201: createDepositResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/deposits",
    },
);
